export const ButtonPlay = {
  bindings: {
    onClick: '&',
  },

  template: `
    <button class="btn btn-play rounded-circle d-flex align-items-center justify-content-center"
      type="button"
      ng-click="$ctrl.onClick()">
      <i class="fa fa-lg fa-play text-white"></i>
    </button>`,
};



// WEBPACK FOOTER //
// ./src/components/Button/ButtonPlay.js